<template>
  <b-container class="chat-box">
    <b-row>
      <b-col cols="12" lg="10" class="mx-auto">
        <div
          v-for="(msg, msgidx) in messages"
          :key="msgidx"
          class="chat-record mt-2"
        >
          <ChatMessageComponent
            :style="{
              '--main-color': mainColor,
              '--secondary-color': mainColor,
            }"
            :initMsg="msg"
            :key="msgidx"
            :msgidx="msgidx"
            :ref="`msgRef-${msg.name}`"
            :context="context"
            @select-card="handleCardClick"
            @increase="handleIncrease"
            @decrease="handleDecrease"
            @continue="continueChat"
            @scroll-to-bottom="scrollToBottom"
            @scroll-to-msg="scrollToMsg"
            @go-to-step="goToStep"
            @select-checkbox="handleCheckbox"
            @set-text-input="setTextInput"
            @selector-change="handleSelectorChange"
          />
          <div>
            <b-row
              v-if="msg.isFinal"
              class="w-100 reset-button py-2 m-1"
              @click="resetChat"
            >
              <b-col>Reiniciar chat</b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <!-- <b-col col lg="2" class="d-none d-sm-block">
          <b-card
            bg-variant="light"
            title="Costo:"
            style="position: sticky; top: 4em"
          >
            <b-card-text>
              <b>{{ cost }}</b>
              <b-img :src="appleIcon" width="22px" class="pl-1 mb-2 mx-0" />
            </b-card-text>
          </b-card>
        </b-col> -->
    </b-row>
  </b-container>
</template>
<script>
import ChatMessageComponent from "./ChatMessageComponent.vue";
import CreateMaterial from "@/components/botpie-assistant/CreateMaterial";
import EurekaTable from "@/components/redpie/miscellaneous/EurekaTable";
import informationService from "@/services/informationService";
import MissionsView from "@/components/utopie/miscellaneous/MissionsView";
import { MEETING_OPTION, meetingQuestion } from "./meetingOffer";
import { REFERRAL_OPTIONS, referralQuestions } from "./referralOffer";
import { ensureReferralRewards } from "./referralRewards";
import { usesLine, usesCardClass, spendsUses } from "./serviceUses";
import { skipAutoScroll } from "./chatScroll";
const SERVICE = "eureka";
// import materialDocumentSocket from "@/mixins/materialDocumentSocket";

export default {
  components: {
    ChatMessageComponent,
    CreateMaterial,
    EurekaTable,
    MissionsView,
  },
  name: "ChatBotMaterials",
  // mixins: [materialDocumentSocket],
  data() {
    return {
      mainColor: "#efba50",
      secondaryColor: "#d9bd70",
      currentQuestionIndex: "welcomeMessage",
      context: { service: "Eureka" },
      answers: {},
      selectedCard: null,
      messages: [],
      prices: {},
      cost: 0,
      appleIcon: require("@/assets/img/icono-manzana.svg"),
      starIcon: require("@/assets/img/icono-estrella.svg"),
      copyIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_link.svg"),
      backIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Íconos_atrás.svg"),
      reviewIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_revisar.svg"),
      types: ["text", "button", "quickReplies"],
      questions: {
        welcomeMessage: {
          name: "welcomeMessage",
          text: `¡Hola ${this.$store.state.login.first_name}! Eureka es una prueba estandarizada en
              Chile para el diagnóstico de DEA, especialmente
              creada para que los establecimientos educativos
              puedan evaluar en el contexto del Programa de
              Integración Escolar y realizar el ingreso a PIE,<br/>
              ${usesLine(SERVICE)}<br/>
              <strong>¿Qué te gustaría hacer?</strong>`,
          type: "options",
          answersLoaded: false,
          single_choice: true,
          answers: [],
          alreadySeen: [],
          process_dic: [
            {
              label: "Conocer más detalles de la prueba",
              nextIndex: "details",
            },
            {
              label: "Ver el tutorial",
              nextIndex: "learn",
            },
            {
              label: "Probarla y ver un ejemplo del informe",
              nextIndex: "try",
              condition: () => {
                return !this.$store.state.login.school;
              },
            },
            {
              label: "Recibir una cotización para mi colegio",
              nextIndex: "bill",
            },
            {
              label: "Aplicar Eureka a un estudiante",
              nextIndex: "use",
              condition: () => {
                return this.$store.state.login.school;
              },
            },
            // Las formas de conseguir usos van en este orden a propósito:
            // invitar primero (es la que más usos reparte y trae gente nueva),
            // luego declarar quién te invitó, y después el resto.
            ...REFERRAL_OPTIONS,
            {
              label: "Comprar usos",
              redirect: "/utopie#/buy_product/eureka",
            },
            {
              label: "Ver misiones y ganar usos",
              nextIndex: "missions",
            },
            MEETING_OPTION,
          ],
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                this.process_dic.forEach((ans) => {
                  if (ans.condition) {
                    if (ans.condition()) {
                      this.answers.push({
                        name: ans.label,
                        isSelected: false,
                        class: "col-md-7 col-12 my-2",
                        bootstrap_classes: "text-left px-2 font-weight-bold",
                        nextQuestionIndex: ans.nextIndex,
                        redirect: ans.redirect,
                        cardClass: usesCardClass(ans, SERVICE),
                      });
                    }
                  } else {
                    this.answers.push({
                      name: ans.label,
                      isSelected: false,
                      class: "col-md-7 col-12 my-2",
                      bootstrap_classes: "text-left px-2 font-weight-bold",
                      nextQuestionIndex: ans.nextIndex,
                      redirect: ans.redirect,
                      cardClass: usesCardClass(ans, SERVICE),
                    });
                  }
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
            // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
          },
        },
        mainMessage: {
          name: "mainMessage",
          text() {
            if (!this.answers.length) {
              return "Has visto todos los mensajes disponibles! Recarga la página para comenzar de nuevo.";
            }
            return `${usesLine(SERVICE)}<br/>
                Ahora, <strong>¿Qué quieres hacer?</strong>`;
          },
          type: "options",
          answersLoaded: false,
          single_choice: true,
          isMain: true,
          vueContext: this,
          answers: [],
          alreadySeen: [],
          process_dic: [
            {
              label: "Conocer más detalles de la prueba",
              nextIndex: "details",
            },
            {
              label: "Ver el tutorial",
              nextIndex: "learn",
            },
            {
              label: "Probarla y ver un ejemplo del informe",
              nextIndex: "try",
              condition: () => {
                return !this.$store.state.login.school;
              },
            },
            {
              label: "Recibir una cotización para mi colegio",
              nextIndex: "bill",
            },
            {
              label: "Aplicar Eureka a un estudiante",
              nextIndex: "use",
              condition: () => {
                return this.$store.state.login.school;
              },
            },
            // Las formas de conseguir usos van en este orden a propósito:
            // invitar primero (es la que más usos reparte y trae gente nueva),
            // luego declarar quién te invitó, y después el resto.
            ...REFERRAL_OPTIONS,
            {
              label: "Comprar usos",
              redirect: "/utopie#/buy_product/eureka",
            },
            {
              label: "Ver misiones y ganar usos",
              nextIndex: "missions",
            },
            MEETING_OPTION,
          ],
          getAnswers(context) {
            this.answers = [];
            return new Promise((resolve) => {
              this.process_dic.forEach((ans) => {
                // Ya usada = ya leída: no se vuelve a ofrecer. La única que
                // repite es la acción del servicio.
                if (!(ans.nextIndex in context) || spendsUses(ans)) {
                  if (ans.condition) {
                    if (ans.condition()) {
                      this.answers.push({
                        name: ans.label,
                        isSelected: false,
                        class: "col-md-7 col-12 my-2",
                        bootstrap_classes: "text-left px-2 font-weight-bold",
                        nextQuestionIndex: ans.nextIndex,
                        redirect: ans.redirect,
                        cardClass: usesCardClass(ans, SERVICE),
                      });
                    }
                  } else {
                    this.answers.push({
                      name: ans.label,
                      isSelected: false,
                      class: "col-md-7 col-12 my-2",
                      bootstrap_classes: "text-left px-2 font-weight-bold",
                      nextQuestionIndex: ans.nextIndex,
                      redirect: ans.redirect,
                      cardClass: usesCardClass(ans, SERVICE),
                    });
                  }
                }
              });
              this.answersLoaded = true;
              resolve(this.answers);
            });
          },
          routine() {
            console.log("routine");
            // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
          },
        },
        details: {
          name: "details",
          text: "¡Perfecto! Aquí te muestro todos los detalles de la prueba Eureka",
          type: "informative",
          nextQuestionIndex: "mainMessage",
          answers: [],
          process_dic: [
            {
              title: "¿Qué dice el Mineduc?",
              text: "El Mineduc no valida, certifica ni recomienda ninguna prueba en particular para el caso de DEA. Tanto en correos oficiales como en las orientaciones ratifican el contenido del decreto 170: cada evaluador puede escoger la prueba diagnóstica. Puedes ver la respuesta oficial del Mineduc en el video.",
              video: "https://www.youtube.com/embed/GegH-98Algo?start=4679",
            },
            {
              title:
                "Estandarizada para el diagnóstico DEA según los lineamientos del decreto 170",
              text: "Eureka está validada, mide el progreso en lectoescritura y cálculo, entregando las desviaciones estándar, lo cual permite el diagnóstico de DEA e ingreso al Programa de Integración Escolar",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_1.png"),
              height: "300",
            },
            {
              title: "Eureka está validada y cuenta con un estudio científico",
              text: "Cuenta con una publicación de validación en la revista Enfoques Educacionales de la Universidad de Chile, que certifica su validez y confiabilidad para el diagnóstico de DEA.",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_2.png"),
              height: "300",
              cellHeight: "150",
            },
            {
              title: "Estandarizada desde 1° Básico hasta 8° Básico",
              text: "Evalúa hasta dos veces al año a un mismo estudiante (las pruebas de media por ahora son informales)",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_3.png"),
              height: "300",
            },
            {
              title: "Enfocada en el progreso de Lenguaje y Matemáticas",
              text: "Mide objetivos de aprendizaje",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_4.png"),
              height: "200",
            },
            {
              title: "Mide habilidades cognitivas",
              text: "Atención, memoria, pensamiento y sub habilidades",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_5.png"),
              height: "300",
            },
            {
              title: "Se rinde de forma digital",
              text: "Los estudiantes la rinden desde un computador, de manera amigable y sencilla",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_6.png"),
              height: "300",
            },
            {
              title: "Incluye distintos tipos de pregunta",
              text: "Alternativas, ordenamiento, respuestas orales y de desarrollo",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_7.png"),
              height: "300",
              cellHeight: "150",
            },
            {
              title: "Se corrige en línea",
              text: "Las preguntas de alternativa se corrigen automaticamente, las preguntas de desarrollo cuentan con una rúbrica precisa",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_8.png"),
              height: "300",
            },
            {
              title: "Genera un informe Psicopedagógico",
              text: "Revisas la prueba y nosotros te entregamos un reporte detallado, lo cual permite el diagnóstico de DEA en Chile, incluyendo las desviaciones estándar.",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_9.png"),
              height: "300",
              cellHeight: "150",
            },
            {
              title:
                "Hemos evaluado más de 10.000 estudiantes con nuestra prueba en Chile",
              text: "Comunas, fundaciones y colegios particulares a lo largo de Chile ya utilizan la batería psicopedagógica Eureka con sus estudiantes en el contexto del Programa de Integración Escolar.",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_10.png"),
              height: "300",
              cellHeight: "150",
            },
            {
              title: "Cuenta con un manual y una capacitación",
              text: "Eureka cuenta con un protocolo estandarizado de aplicación para el diagnóstico de DEA, los profesionales educadores diferenciales y psicopedagogos pueden acceder al manual de aplicación y la capacitación virtual de la plataforma.",
              image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_11.png"),
              height: "300",
            },
            {
              title: "Preguntas Frecuentes",
            },
            {
              title:
                "¿Qué prueba se debe ocupar para el diagnóstico de DEA según el decreto 170?",
              text: "El decreto 170 no obliga ninguna prueba específica para el diagnóstico de DEA. La prueba a escoger para el diagnóstico es de criterio del evaluador, siempre y cuando cumpla con ciertas características estipuladas en el decreto (las características se especifican en los artículos 2, 28 y 29).<br/>Artículo 28.- Los profesionales competentes deberán elegir los instrumentos evaluativos de carácter psicopedagógicos que sean pertinentes con la edad, el curso y la cultura a la cual pertenece el o la estudiante.",
            },
            {
              title:
                "¿Cómo escojo la prueba diagnóstica de DEA a utilizar para cumplir con el decreto 170?",
              text: "La prueba a escoger debe cumplir con 3 criterios solicitados en el decreto 170, debe ser validada en Chile en las áreas de comprensión lectora, nivel lector, habilidades psicolingüísticas, escritura y matemáticas, entregando las desviaciones estándar en lectoescritura y cálculo.<br/>Art. 2c.- Una prueba válida y confiable<br/>Art. 28.- La prueba debe ser validada en las áreas de: comprensión lectora, nivel lector, habilidades psicolingüística, escritura y matemáticas.<br/>Art. 29b.- El estudiante se debe ubicar 2 DV estándar bajo la media en lectoescritura o cálculo.",
            },
            {
              title:
                "¿Eureka cumple los criterios de prueba diagnóstica según el decreto 170?, ¿La valida el Mineduc?",
              text: "Sí, el decreto en su artículo 2c estipula que las pruebas diagnósticas deben garantizar validez, confiabilidad y consistencia. Eureka es una prueba validada en Chile y cuenta con un paper de validación publicado por la revista de la Universidad de Chile Enfoques Educacionales.<br/>Según el artículo 2c. el decreto 170 entiende que una prueba diagnóstica es:<br/>- Artículo 2 c. Aquellas herramientas y procedimientos de observación y medición que permiten evaluar de manera cuantitativa y/o cualitativa al estudiante en el ámbito de exploración requerido y que garanticen validez, confiabilidad y consistencia, así como obtener información certera acerca del o la estudiante, el contexto escolar y familiar en el que participa.",
            },
            {
              title:
                "¿La prueba estandarizada Eureka entrega las desviaciones estándar?",
              text: "Sí, Eureka entrega las desviaciones estándar en cálculo y lectoescritura según lo estipulado en el decreto 170 artículo 29b, lo cual permite el diagnóstico de DEA e ingreso a PIE.<br/>- Artículo 29 b: En las evaluaciones con normas estandarizadas, rinde por lo menos, dos desviaciones por debajo del estándar esperado para su nivel de edad, de inteligencia y de escolaridad.",
            },
            {
              title:
                "¿La prueba estandarizada Eureka mide lo que pide el decreto para el diagnóstico?",
              text: "Sí, Eureka está creada de acuerdo a los lineamientos del decreto 170, según lo estipulado en el artículo 29, midiendo el nivel de desempeño y posible dificultad en las áreas de Comprensión oral, Expresión Oral, Comprensión lectora, Expresión Escrita, Cálculo y Resolución de problemas matemáticos.<br/><br/>- Artículo 29.a: El o la estudiante no progresa adecuadamente y sus dificultades son significativamente mayores que otros niños o niñas de su misma edad o curso, en las áreas de: expresión oral, comprensión oral, destrezas básicas lectoras, habilidades de fluidez lectora, comprensión lectora, expresión escrita, cálculo matemático, solución de problemas matemáticos, aun cuando se le han proporcionado las experiencias de aprendizaje y la instrucción apropiada a sus necesidades individuales de aprendizaje (ritmo y estilo de aprendizaje y conocimientos previos).",
            },
            {
              title:
                "¿Puede ocuparse la prueba estandarizada Eureka para el diagnóstico de DEA en el contexto del Programa de Integración Escolar?",
              text: "Sí, dado que está validada en Chile (cuenta con un paper de validación), indica las principales dificultades en los ejes indicados en el decreto para lenguaje y matemáticas, entregando las desviaciones estándar en lectoescritura y cálculo, cumpliendo de esta forma los lineamientos solicitados por el decreto 170.",
            },
          ],
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                this.process_dic.forEach((ans) => {
                  this.answers.push({
                    title: ans.title,
                    text: ans.text,
                    image: ans.image,
                    video: ans.video,
                    height: ans.height,
                    cellHeight: ans.cellHeight,
                    class: "col-12 col-md-12 mb-2",
                  });
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
            // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
          },
        },
        learn: {
          name: "learn",
          text: "¡Genial!, la capacitación Oficial muestra el procedimiento estandarizado de aplicación que debe respetarse para que la evaluación permita el diagnóstico, aquí te presento el video y el manual. Cuando hayas revisado ambos elementos puedes continuar:",
          type: "informative",
          nextQuestionIndex: "mainMessage",
          answers: [],
          vueContext: this,
          process_dic: [
            {
              text(template) {
                return (
                  "Descarga el Manual haciendo <a href='" +
                  template +
                  "' target='_blank' rel='noopener'>click aquí</a>"
                );
              },
              image: require("@/assets/img/eureka_chatbot_icons/mini_portada_manual.png"),
              width: "300",
            },
            {
              text() {
                return "Recomendamos ver el video hasta el final antes de continuar";
              },
              video: "https://www.youtube.com/embed/V7868MKYvz8",
            },
          ],
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                this.process_dic.forEach((ans) => {
                  this.answers.push({
                    title: ans.title,
                    text: ans.text(this.vueContext.template),
                    image: ans.image,
                    width: ans.width,
                    video: ans.video,
                    class: "col-12 col-md-12 mb-2",
                  });
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
          },
        },
        try: {
          name: "try",
          text: "¡Perfecto! ¿Qué curso quieres revisar?",
          type: "options",
          answersLoaded: false,
          single_choice: true,
          answers: [],
          alreadySeen: [],
          process_dic: [],
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                informationService.getPieGrades().then((data) => {
                  let grades = data.grades_by_level.filter(
                    (element) => element.label === "Básica"
                  )[0].levels;
                  grades.forEach((ans) => {
                    this.answers.push({
                      name: ans.name.slice(0, 2),
                      isSelected: false,
                      class: "col-md-1 col-3 my-2",
                      bootstrap_classes: "text-center font-weight-bold",
                      nextQuestionIndex: "eureka_demo",
                      code: ans.code,
                    });
                  });
                  console.log(data);
                });
                resolve(this.answers);
              });
            }
          },
          routine() {
            console.log("routine");
          },
        },
        eureka_demo: {
          name: "eureka_demo",
          text: () => {
            const copyIcon = require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_link.svg");
            const reviewIcon = require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_revisar.svg");
            const downloadIcon = require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_descargar.svg");
            const coinIcon = require("@/assets/img/eureka_icons/eureka_svg_icons/coin_icon.png");
            if (!this.$store.state.login.school) {
              return `<div class="text-left"><strong>Creamos para ti tres estudiantes de prueba.<br> Ahora puedes:</strong><br>
                <ol>
                  <li> <img src='${copyIcon}' width='22px' class='pl-1 mb-2'/></img> Copiar el link de la prueba y enviarlo al estudiante
   para realizar una evaluación </li>
                  <li> <img src='${reviewIcon}' width='22px' class='pl-1 mb-2'/></img> Revisar una evaluación que ya fue rendida </li>
                  <li> <img src='${downloadIcon}' width='22px' class='pl-1 mb-2'/></img> Descargar un informe completo (ambas pruebas deben estar listas) </li>
                  <li> <img src='${coinIcon}' width='22px' class='pl-1 mb-2'/></img> Te cobraremos un uso en total por revisar y cerrar ambas evaluaciones (con ello podrás descargar el informe) </li>
                </ol></div>`;
            } else {
              return `<div class="text-left"><strong>Ya tenías un colegio de prueba o real asociado.<br> Ahora puedes:</strong><br>
                <ol>
                  <li> <img src='${copyIcon}' width='22px' class='pl-1 mb-2'/></img> Copiar el link de la prueba y enviarlo al estudiante
   para realizar una evaluación </li>
                  <li> <img src='${reviewIcon}' width='22px' class='pl-1 mb-2'/></img> Revisar una evaluación que ya fue rendida </li>
                  <li> <img src='${downloadIcon}' width='22px' class='pl-1 mb-2'/></img> Descargar un informe completo (ambas pruebas deben estar listas) </li>
                  <li> <img src='${coinIcon}' width='22px' class='pl-1 mb-2'/></img> Te cobraremos un uso en total por revisar y cerrar ambas evaluaciones (con ello podrás descargar el informe) </li>
                </ol></div>`;
            }
          },
          type: "custom-component",
          answersLoaded: true,
          answers: [],
          component: EurekaTable,
          dontShowNextButton: true,
          nextQuestionIndex: "mainMessage",
          routine: () => {},
        },
        bill: {
          name: "bill",
          text: "¡Excelente! Indícanos tu correo y la cantidad de aplicaciones a cotizar y te enviaremos la cotización.",
          type: "inputs",
          answersLoaded: true,
          answers: [
            {
              name: "email",
              type: "email",
              placeholder: "Escribe tu correo aquí",
              class: "col-12 col-md-6 mb-2",
            },
            {
              name: "applications",
              type: "number",
              placeholder: "Cantidad de aplicaciones",
              class: "col-12 col-md-6 mb-2",
            },
          ],
          nextMessage: "Obtener cotización!",
          extraFunction: (data) => {
            informationService
              .sendEurekaBill({
                email: data.email,
                applications: data.applications,
                service: "EUR_STU"
              })
              .then((resp) => {
                this.$toasted.success(resp.message);
              });
          },
          nextQuestionIndex: "mainMessage",

          routine: () => {},
        },
        use: {
          name: "use",
          text: () => {
            const copyIcon = require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_link.svg");
            const reviewIcon = require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_revisar.svg");
            const downloadIcon = require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_descargar.svg");
            const coinIcon = require("@/assets/img/eureka_icons/eureka_svg_icons/coin_icon.png");
            return `<div class="text-left"><strong>Debes añadir a tus estudiantes, incorporando RUT y nombre completo. Una vez incorporados puedes:</strong><br>
                <ol>
                  <li> <img src='${copyIcon}' width='22px' class='pl-1 mb-2'/></img> Copiar el link de la prueba y enviarlo al estudiante
   para realizar una evaluación </li>
                  <li> <img src='${reviewIcon}' width='22px' class='pl-1 mb-2'/></img> Revisar una evaluación que ya fue rendida </li>
                  <li> <img src='${downloadIcon}' width='22px' class='pl-1 mb-2'/></img> Descargar un informe completo (ambas pruebas deben estar listas) </li>
                  <li> <img src='${coinIcon}' width='22px' class='pl-1 mb-2'/></img> Te cobraremos un uso en total por revisar y cerrar ambas evaluaciones (con ello podrás descargar el informe) </li>
                </ol></div>`;
          },
          type: "custom-component",
          answersLoaded: true,
          answers: [],
          component: EurekaTable,
          dontShowNextButton: true,
          nextQuestionIndex: "mainMessage",
          routine: () => {},
        },
        meeting: meetingQuestion(),
        ...referralQuestions(this, "mainMessage", SERVICE),
        missions: {
          name: "missions",
          text: () => {
            return `<div class="text-left"><strong>Puedes conseguir usos gratis realizando las siguientes acciones!</strong>`;
          },
          type: "custom-component",
          answersLoaded: true,
          answers: [],
          component: MissionsView,
          dontShowNextButton: true,
          nextQuestionIndex: "mainMessage",
          routine: () => {},
        },
      },
      template: "",
    };
  },
  mounted() {
    // Se pregunta acá, al montar, y no cuando la persona abre el referido: el
    // guard que decide si el referido se ofrece (`referralRewardsKnownEmpty`)
    // sólo se enteraba dentro de la vista de invitar, o sea después del clic
    // que queremos evitar. Es idempotente por servicio y falla abierto.
    ensureReferralRewards(SERVICE);
    this.getEurekaManual();
    let question = this.questions[this.currentQuestionIndex];
    this.messages.push(question);
    this.context[question.name] = {};
    this.$store.commit("chatbot/clear");
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex];
    },
    school() {
      return this.$store.state.login.school;
    },
    year() {
      return this.$store.state.login.year;
    },
  },
  methods: {
    getEurekaManual() {
      informationService.getEurekaManual().then((data) => {
        this.template = data.template;
      });
    },
    handleCardClick(answer, msgidx, ansidx, max) {
      if (this.messages[msgidx].name === this.currentQuestion.name) {
        this.selectCard(msgidx, ansidx, answer, max);
        this.selectAnswer();
      }
    },
    handleIncrease(opt, answer) {
      if (opt.price) {
        if (opt.count === 0) {
          if (this.cost + opt.price <= this.$store.state.login.points) {
            this.cost += opt.price;
            opt.count++;
            answer.oaInds++;
          } else {
            this.$toasted.error(
              "No cuentas con aportes suficientes para realizar esta acción!"
            );
          }
        } else {
          if (opt.count < 2) {
            opt.count++;
            answer.oaInds++;
          }
        }
      } else {
        opt.count++;
        answer.oaInds++;
      }
    },
    handleDecrease(opt, answer) {
      if (opt.count > 0) {
        if (opt.price && opt.count === 1) {
          this.cost -= opt.price;
          opt.count--;
          answer.oaInds--;
        } else {
          opt.count--;
          answer.oaInds--;
        }
      }
    },
    async continueChat() {
      // hacer switch para disstintos tipos de pregunta
      switch (this.currentQuestion.type) {
        case "options":
          if (this.currentQuestion.single_choice) {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.find((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answer",
              value: this.context[this.currentQuestion.name],
            });
            if (this.context[this.currentQuestion.name].redirect) {
              window.location.href = this.context[this.currentQuestion.name].redirect;
              return;
            }
          } else {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name],
            });
          }
          break;
        case "options-counter":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;

        case "cards":
          if (this.currentQuestion.single_choice) {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.find((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answer",
              value: this.context[this.currentQuestion.name],
            });
          } else {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name],
            });
          }
          break;
        case "hybrid-options":
          // si optionalCheckbox es true, entonces type es option-counter si no, es multiple choice como cards
          if (this.currentQuestion.optionalCheckbox) {
            this.context[this.currentQuestion.name].answers =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name].answers,
            });
          } else {
            this.context[this.currentQuestion.name].answers =
              this.currentQuestion.answers.filter((ans) => ans.count > 0);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name].answers,
            });
          }
          break;
        case "text-area":
          this.context[this.currentQuestion.name].textInput =
            this.currentQuestion.textInput;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "textInput",
            value: this.context[this.currentQuestion.name].textInput,
          });
          break;
        case "selector-options":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        case "material":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        case "multiple-text":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        default:
          break;
      }

      this.messages.slice(-1)[0].answered = true;
      if (!this.currentQuestion.isFinal) {
        await this.currentQuestion.routine();
        // update store if the method updateStore exists in the question
        if (this.currentQuestion.updateStore) {
          this.currentQuestion.updateStore(this.context);
        }
        if (!this.currentQuestion.single_choice) {
          if (typeof this.currentQuestion.nextQuestionIndex === "function") {
            this.currentQuestionIndex = this.currentQuestion.nextQuestionIndex(
              this.context
            );
          } else {
            this.currentQuestionIndex = this.currentQuestion.nextQuestionIndex;
          }
        } else {
          this.currentQuestionIndex =
            this.context[this.currentQuestion.name] &&
            this.context[this.currentQuestion.name].nextQuestionIndex
              ? this.context[this.currentQuestion.name].nextQuestionIndex
              : this.currentQuestion.nextQuestionIndex;
        }
        if (this.currentQuestionIndex == "reset") {
          this.resetChat();
        } else {
          this.loadQuestion(this.currentQuestionIndex);
        }
        this.context["currentQuestionIndex"] = this.currentQuestionIndex;
        this.$store.commit("chatbot/updateMessage", {
          name: "currentQuestionIndex",
          key: "value",
          value: this.currentQuestionIndex,
        });
      }
    },
    selectCard(msgidx, answeridx, answer, max) {
      if (this.currentQuestion.single_choice) {
        this.messages[msgidx].answers.forEach((ans) => {
          if (ans.price && ans.isSelected) {
            this.cost -= ans.price;
          }
          ans.isSelected = false;
        });
      }
      if (answer.price && !answer.isSelected) {
        if (this.cost + answer.price <= this.$store.state.login.points) {
          if (
            !max ||
            (max &&
              this.messages[msgidx].answers.filter((ans) => ans.isSelected)
                .length < max)
          ) {
            this.cost += answer.price;
            answer.isSelected = true;
          } else {
            this.$toasted.error(
              "Ya has seleccionado el máximo de " + max + " elementos"
            );
          }
        } else {
          this.$toasted.error(
            "No cuentas con aportes suficientes para realizar esta acción!"
          );
        }
      } else {
        if (answer.price && answer.isSelected) {
          this.cost -= answer.price;
        }
        if (
          answer.isSelected ||
          !max ||
          (max &&
            this.messages[msgidx].answers.filter((ans) => ans.isSelected)
              .length < max)
        ) {
          this.messages[msgidx].answers[answeridx].isSelected =
            !this.messages[msgidx].answers[answeridx].isSelected;
        } else {
          this.$toasted.error(
            "Ya has seleccionado el máximo de " + max + " elementos"
          );
        }
      }
    },
    resetValues() {
      this.selectedCard = null;
    },

    setText(sourceObj, keyObj, targetObj, keyTarget) {
      return new Promise((resolve) => {
        // resolve content
        let content =
          typeof sourceObj[keyObj] === "function"
            ? sourceObj[keyObj]()
            : sourceObj[keyObj];

        // type effect
        let i = 0;
        // targetObj[keyTarget] = "";
        let timer = setInterval(() => {
          if (i < content.length && content.charAt(i)) {
            targetObj[keyTarget] += content.charAt(i);

            i++;

            this.$forceUpdate();
          } else {
            clearInterval(timer);
            resolve();
          }
        }, 1);
      });
    },
    loadQuestion(questionIndex) {
      try {
        let question = this.questions[questionIndex];
        this.context[question.name] = {};
        this.messages.push(question);
      } catch (error) {
        console.log(error);
      }
    },

    goToStep(stepName) {
      if (stepName === "reset") {
        this.resetChat();
        return;
      }
      let question = this.questions[stepName];
      if (!question) return;
      // A custom-component step (the Eureka table) auto-continues on mount, so
      // mainMessage is already sitting below it — but its text and its
      // highlighted options were built with the old uses balance. Drop that
      // copy and re-render the step so it reflects the current one; the pop has
      // to land in the DOM before the push, or Vue reuses the component and
      // mounted() (where text and answers are built) never runs again.
      if (this.messages.slice(-1)[0].name === stepName) {
        this.messages.pop();
      }
      question.answered = false;
      this.currentQuestionIndex = stepName;
      this.$nextTick(() => {
        this.loadQuestion(stepName);
        // The step lands under the Eureka table, way off-screen. Don't wait for
        // the message's own scroll-to-msg: that only fires once the text has
        // finished typing itself out, seconds later.
        this.$nextTick(() => this.scrollToMsg(stepName));
      });
    },
    selectAnswer() {
      if (this.currentQuestion.single_choice) {
        this.continueChat();
      }
    },
    scrollToBottom() {
      let container = document.querySelector(".global-container");
      // container.scrollIntoView();
      window.scrollTo(0, container.scrollHeight);
    },

    scrollToMsg(name) {
      if (skipAutoScroll(this.messages, name)) return;
      const msgRef = this.$refs[`msgRef-${name}`];
      if (!msgRef || !msgRef.length) return;
      const parentMsg = msgRef.at(-1).$el.parentNode;

      // "start", not "center": a message taller than the viewport (the details
      // card list) would otherwise land the user in the middle of it.
      parentMsg.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      // const scrollOffset = parentMsg.offsetTop;

      // window.scrollTo(0, scrollOffset);
    },
    resetChat() {
      // this.messages = [];
      // this.answers = {};
      // this.currentQuestionIndex = "type";
      // this.loadQuestion(this.currentQuestionIndex);
      this.$emit("toggle-reload");
    },
    handleCheckbox(msgidx, value) {
      this.messages[msgidx].optionalCheckbox = value;
      this.context[this.currentQuestion.name].optionalCheckbox = value;
    },
    setTextInput(msgidx, value) {
      this.messages[msgidx].textInput = value;
      this.context[this.currentQuestion.name].textInput = value;
    },
    handleSelectorChange(msgidx, idx, value) {
      this.messages[msgidx].answers[idx].selected = value;
      this.context[this.currentQuestion.name].answers =
        this.messages[msgidx].answers;
    },
  },
  watch: {
    cost(val) {
      this.$emit("set-cost", val);
    },
  },
};
</script>
<style>
.global-container {
  margin: 0;
  padding: 0;
  min-height: 100%;
}

.image-container {
  background-image: url("../../assets/img/botpie/mancha.svg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center bottom;
}

.chat-box {
  margin: 10px;
  width: 100vw;
  margin-left: auto;
  margin-right: auto;
  align-items: space-between;
  justify-content: space-between;
}

/* RESET BUTTON */
/* CONTINUE BUTTON */
.reset-button {
  border-radius: 5px;
  border: 2pt solid rgb(0, 0, 0) !important;
  font-family: "Ubuntu Medium", Arial, sans-serif;
  font-weight: bold; /* Aplica negrita al texto */
  cursor: pointer;
}
</style>
